import React from 'react';
import { ProgressInnerText } from './ProgressInnerText';
import { progressBlock } from './constants';
import { getOffset, getTheme } from './utils';
export function ProgressWithValue(props) {
    const { value, loading, text } = props;
    const offset = getOffset(value);
    if (!Number.isFinite(value)) {
        return null;
    }
    return (React.createElement("div", { className: progressBlock('item', { theme: getTheme(props), loading }), style: { transform: `translateX(calc(var(--g-flow-direction) * ${offset}%))` } },
        React.createElement(ProgressInnerText, { offset: offset, text: text })));
}
